/**
 * Created by Qingger Corp.
 * User: tanjianzhen
 * Date: 2018-6-26
 * Time: 11:07
 * Desc:
 */
import Vue from 'vue';

function DataTransfer(data) {
  if (!(this instanceof DataTransfer)) {
    // @ts-expect-error : 使用JS语法
    return new DataTransfer(data, null, null);
  }
}

DataTransfer.treeToArray = function treeToArray(data, parent, level, expandedAll) {
  let tmp = [];

  Array.from(data).forEach((record) => {
    // isHovered和isEditing 是商品分类配置页面的变量，不要删
    // @ts-expect-error : 使用JS语法
    Vue.set(record, 'isHovered', false);
    // @ts-expect-error : 使用JS语法
    Vue.set(record, 'isEditing', false);
    // @ts-expect-error : 使用JS语法
    if (record._expanded === undefined) {
      // @ts-expect-error : 使用JS语法
      Vue.set(record, '_expanded', expandedAll);
    }
    if (parent) {
      // @ts-expect-error
      Vue.set(record, '_parent', parent);
    }
    let _level = 0;
    if (level !== undefined && level !== null) {
      _level = level + 1;
    }

    // @ts-expect-error: 使用JS语法
    Vue.set(record, '_level', _level);
    tmp.push(record);

    // @ts-expect-error: 使用JS语法
    if (record.children && record.children.length > 0) {
      // @ts-expect-error : 使用JS语法
      const children = DataTransfer.treeToArray(record.children, record, _level, expandedAll);
      tmp = tmp.concat(children);
    }
  });
  return tmp;
};

export default DataTransfer;
